export const locale = {
  lang: "en-CA",
  data: {
    UPSALE_QUESTIONS_PANEL: {
      TITLE: "Upsale",
      SEARCH: "Search a question",
      LEFT_LIST_LABEL: "Drag & drop or use the + button to add question",
      RIGHT_LIST_LABEL: "List of questions to add",
      NO_RESULTS: "No results",
      NO_ATTACHED: "No question attached to this product.",
      CREATE_QUESTION: "Create question",
    },
  },
};
